
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { filter, Subscription } from 'rxjs';
import { LayoutService } from '../../services/layout.service';
import { TopbarComponent } from '../topbar/topbar.component';
import { MenuItem } from 'primeng/api';
import { AuthService } from '../../services/auth.service';
import { PanelMenuModule } from 'primeng/panelmenu';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterModule,
    DrawerModule,
    PanelMenuModule,
    TopbarComponent
],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit, OnDestroy {
  isSideBarVisibleSubscription: Subscription;
  isSidebarVisible: boolean = false;

  userAuthenticatedSubscription: Subscription;
  private userAuthenticated: boolean = false;

  menuLinks: MenuItem[] = [];


  constructor(
    private layoutService: LayoutService,
    private authService: AuthService,
    private router: Router) {

    this.isSideBarVisibleSubscription = this.layoutService.sideBarVisiblityChanged.subscribe(isVisible => {
      this.isSidebarVisible = isVisible;
    });

    this.userAuthenticatedSubscription = this.authService.loginChanged.subscribe(res => {
      if (res) {
        this.userAuthenticated = true;
        this.setMenuLinks();
      }
    });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.hideMenu();
    });
  }

  ngOnInit(): void {
    this.userAuthenticated = this.authService.isAuthenticated();
    this.setMenuLinks();
  }

  ngOnDestroy() {
    if (this.isSideBarVisibleSubscription) {
      this.isSideBarVisibleSubscription.unsubscribe();
    }

    if (this.userAuthenticatedSubscription) {
      this.userAuthenticatedSubscription.unsubscribe();
    }
  }

  private hideMenu() {
    this.isSidebarVisible = false;
  }

  private setMenuLinks() {
    this.menuLinks = [];

    if (this.userAuthenticated) {
      this.menuLinks = [
          {
            label: 'Configurazione',
            icon: 'fas fa-wrench',
            styleClass: 'text-decoration-none',
            items: [
              {
                label: 'Organizzazioni',
                icon: 'far fa-address-book',
                routerLink: '/organizations'
              },
              {
                label: 'Squadre',
                icon: 'fas fa-sitemap',
                routerLink: '/teams'
              },
              {
                label: 'Utenti',
                icon: 'fas fa-users',
                routerLink: '/users'
              }
            ]
        },
        {
          label: 'Sessioni',
          icon: 'fas fa-trophy',
          styleClass: 'text-decoration-none',
          items: [
            {
              label: 'Gestione',
              icon: 'far fa-folder',
              routerLink: '/sessions'
            }
          ]
        }]
    }
  }
}
